import { endOfDay, endOfMonth, endOfWeek, startOfDay, startOfMonth, startOfWeek } from 'date-fns';
import { toZonedTime, fromZonedTime } from 'date-fns-tz';

const calcZonedDate = (date: Date | number, tz: string, fn: (date: Date | number) => Date) => {
  const inputZoned = toZonedTime(date, tz);
  const fnZoned = fn(inputZoned);

  return fromZonedTime(fnZoned, tz);
};

export const getZonedEndOfDay = (date: Date | number, timeZone: string) => {
  return calcZonedDate(date, timeZone, endOfDay);
};

export const getZonedEndOfWeek = (date: Date | number, timeZone: string) => {
  return calcZonedDate(date, timeZone, (date) => endOfWeek(date, { weekStartsOn: 1 }));
};

export const getZonedEndOfMonth = (date: Date | number, timeZone: string) => {
  return calcZonedDate(date, timeZone, endOfMonth);
};

export const getZonedStartOfDay = (date: Date | number, timeZone: string) => {
  return calcZonedDate(date, timeZone, startOfDay);
};

export const getZonedStartOfWeek = (date: Date | number, timeZone: string) => {
  return calcZonedDate(date, timeZone, (date) => startOfWeek(date, { weekStartsOn: 1 }));
};

export const getZonedStartOfMonth = (date: Date | number, timeZone: string) => {
  return calcZonedDate(date, timeZone, startOfMonth);
};
